module.exports = __webpack_public_path__ + "static/media/icon-piece5-3.867443df.png";